import { render, staticRenderFns } from "./NotificationEditor.vue?vue&type=template&id=533bdc6b&scoped=true&"
import script from "./NotificationEditor.vue?vue&type=script&lang=js&"
export * from "./NotificationEditor.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEditor.vue?vue&type=style&index=0&id=533bdc6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533bdc6b",
  null
  
)

export default component.exports